
(function () {
  function initHelp() {
  var root = document.querySelector('.ww-help');
  if (!root || root.dataset.searchReady) return;
  root.dataset.searchReady = 'true';
  var input = document.getElementById('hcSearch');
  var clearBtn = document.getElementById('hcClearSearch');
  var resultsCount = document.getElementById('hcResultsCount');
  var resultsWrap = document.getElementById('hcSearchResults');
  var resultsHint = document.getElementById('hcSearchResultsHint');
  var resultsList = document.getElementById('hcSearchResultsList');
  var toc = document.getElementById('hcToc');
  var sectionsWrap = document.getElementById('hcSections');
  var items = Array.prototype.slice.call(document.querySelectorAll('.hc-item'));
  var questions = Array.prototype.slice.call(document.querySelectorAll('.hc-q'));

  function norm(s) {
    return (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function cleanText(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (m) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[m];
    });
  }

  function closeAll() {
    items.forEach(function(item){ item.open = false; });
  }

  function renderResults(matches, query) {
    resultsList.innerHTML = '';
    if (!query) {
      resultsWrap.classList.remove('active');
      toc.style.display = '';
      sectionsWrap.style.display = '';
      resultsHint.textContent = 'Passende Antworten erscheinen direkt hier oben.';
      return;
    }

    resultsWrap.classList.add('active');
    toc.style.display = 'none';
    sectionsWrap.style.display = 'none';

    if (!matches.length) {
      resultsHint.textContent = 'Keine passenden Ergebnisse gefunden. Versuche ein anderes Stichwort.';
      return;
    }

    resultsHint.textContent = 'Klicke auf „Antwort anzeigen“, um direkt zur vollständigen Antwort zu springen.';

    matches.forEach(function(item){
      var qBtn = item.querySelector('.hc-q');
      var answer = item.querySelector('.hc-a');
      var section = item.closest('.hc-section');
      var teaser = cleanText(answer.textContent).slice(0, 220);
      if (teaser.length >= 220) teaser += '…';
      var card = document.createElement('div');
      card.className = 'hc-search-card';
      card.innerHTML = '<h3>' + escapeHtml(qBtn.innerText.replace('+','').trim()) + '</h3>' +
        '<p>' + escapeHtml(teaser) + '</p>' +
        '<a class="hc-search-jump" href="#' + qBtn.id + '">Antwort anzeigen</a>' +
        '<div class="hc-muted" style="margin-top:8px;font-size:13px;">Thema: ' + escapeHtml(section.querySelector('h2').innerText) + '</div>';
      card.querySelector('a').addEventListener('click', function(e){
        e.preventDefault();
        input.value = '';
        filterItems();
        closeAll();
        item.open = true;
        qBtn.scrollIntoView({behavior:'smooth', block:'center'});
      });
      resultsList.appendChild(card);
    });
  }

  function filterItems() {
    var query = norm(input.value);
    var words = query ? query.split(' ') : [];
    var matches = [];

    items.forEach(function(item){
      var hay = norm(item.getAttribute('data-hc')) + ' ' + norm(item.textContent);
      var ok = words.every(function(word){ return !word || hay.indexOf(word) !== -1; });
      if (ok) matches.push(item);
    });

    if (!query) {
      resultsCount.textContent = 'Alle Themen werden angezeigt.';
      clearBtn.style.display = 'none';
    } else {
      resultsCount.textContent = matches.length + ' passende Ergebnisse gefunden.';
      clearBtn.style.display = 'inline-flex';
    }

    renderResults(matches, query);
  }

  input.addEventListener('input', filterItems);
  clearBtn.addEventListener('click', function(){
    input.value = '';
    filterItems();
    input.focus();
  });
}
  initHelp();
  document.addEventListener('shopify:section:load', initHelp);
  new MutationObserver(initHelp).observe(document.body, { childList: true, subtree: true });
})();
